export default __webpack_public_path__ + "static/media/carpet.77e77157.png";